<template>
    <div class="cloud">
        <div :class="['top','topF',scrollTop>bannerHeight?'topF':'','clearfix']">
            <div class="topBg"></div>
            <img src="/cloud/logoT.png" @click="gotoManage" class="topLogo"/>
            <div class="topContent clearfix">
                <!-- <img v-show="scrollTop > bannerHeight" src="/cloud/logoC.png" class="topLogo"/> -->
                <div class="meunList clearfix">
                    <div class="meun">首页</div>
                    <div class="meun" @click="navJump">SAAS云链</div>
                    <div class="meun meunChecked">谱木圈</div>
                </div>
            </div>
        </div>
        <img src="/cloud/cloudBG.jpg" ref="bannerImg" @load="loadImg" class="CloudBanner"/>
        <div class="cloudCountBox">
            <div class="selectConditionBox" ref="searchContent">
                <div class="selectCompany">
                    <div class="title">
                        <div>同行资源</div>
                        <div class="other_type_box clearfix">
                            <div class="other_type">硬木</div>
                            <img src="/cloud/share1.png" class="other_type_img">
                        </div>
                    </div>
                    <div class="companyBoxC">
                        <div class="companyBox clearfix">
                            <div v-show="item.isShow" :class="['companyC',item.isChecked?'companyChecked':'']" @click="selectItem(item.name,'company')" v-for="item in selectCondition.company" :key="item.name" >
                                <img :src="item.picture" class="companyLogo"/>
                                <img src="/cloud/gou.png" v-if="item.isChecked" class="companyGou"/>
                                <div class="companyNameBox">
                                    <div class="companyNameBg"></div>
                                    <div class="companyName">{{item.name}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="more" @click="getMore('company')">
                        <span class="moreName">{{selectMore.company?"收起":"更多"}}</span>
                        <img src="/cloud/share2.png" :class="['moreImg',selectMore.company?'moreImgChecked':'']"/>
                    </div>
                </div>
                <div class="selectCompany">
                    <div class="titleC">品名:</div>
                    <div class="companyBoxC">
                        <div class="companyBox clearfix">
                            <div v-show="item.isShow" @click="selectItem(item.name,'breed')" v-for="(item,index) in selectCondition.breed" :key="index+'_p'" :class="['conditionName',item.isChecked?'conditionNameChecked':'']">{{item.name}}</div>
                        </div>
                    </div>
                    <div class="more" @click="getMore('breed')">
                        <span class="moreName">{{selectMore.breed?"收起":"更多"}}</span>
                        <img src="/cloud/share2.png" :class="['moreImg',selectMore.breed?'moreImgChecked':'']"/>
                    </div>
                </div>
                <div class="selectCompany">
                    <div class="titleC">品牌:</div>
                    <div class="companyBoxC">
                        <div class="companyBox clearfix">
                            <div v-show="item.isShow" @click="selectItem(item.name,'brand')" v-for="(item,index) in selectCondition.brand" :key="index+'_p'" :class="['conditionName',item.isChecked?'conditionNameChecked':'']">{{item.name}}</div>
                        </div>
                    </div>
                    <div class="more" @click="getMore('brand')">
                        <span class="moreName">{{selectMore.brand?"收起":"更多"}}</span>
                        <img src="/cloud/share2.png" :class="['moreImg',selectMore.brand?'moreImgChecked':'']"/>
                    </div>
                </div>
                <div class="selectCompany">
                    <div class="titleC">等级:</div>
                    <div class="companyBoxC">
                        <div class="companyBox clearfix">
                            <div v-show="item.isShow" @click="selectItem(item.name,'grade')" v-for="(item,index) in selectCondition.grade" :key="index+'_p'" :class="['conditionName',item.isChecked?'conditionNameChecked':'']">{{item.name}}</div>
                        </div>
                    </div>
                    <div class="more" @click="getMore('grade')">
                        <span class="moreName">{{selectMore.grade?"收起":"更多"}}</span>
                        <img src="/cloud/share2.png" :class="['moreImg',selectMore.grade?'moreImgChecked':'']"/>
                    </div>
                </div>
                <div class="clearfix">
                    <div class="selectCompany" style="float:left;">
                        <div class="titleC titleCO">规格:</div>
                        <div class="companyBox companyBoxInp clearfix">
                            <div class="companyInpBox clearfix">
                                <div class="companyInpName">厚度</div>
                                <el-input class="companyInp companyInpG"  v-model="param.s_cloud_thickness"/>
                                <!-- <div class="companyInpName">~</div>
                                <el-input class="companyInp" v-model="param.e_cloud_thickness"/> -->
                            </div>
                            <div class="companyInpBox clearfix">
                                <div class="companyInpName">长度</div>
                                <el-input class="companyInp companyInpG" v-model="param.s_cloud_length"/>
                                <!-- <div class="companyInpName">~</div>
                                <el-input class="companyInp" v-model="param.e_cloud_length"/> -->
                            </div>
                        </div>
                    </div>
                    <div class="selectCompany" style="float:left;padding-left:65px;">
                        <div class="titleC titleCO" style="width:65px;">价格区间:</div>
                        <div class="companyBox companyBoxInp clearfix">
                            <div class="companyInpBox clearfix">
                                <el-input class="companyInp"  v-model="param.s_cloud_sales_price"/>
                                <div class="companyInpName">~</div>
                                <el-input class="companyInp" v-model="param.e_cloud_sales_price"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="selectBtnList clearfix">
                    <div class="selectReset" @click="reset">重置</div>
                    <div class="selectBtnChecked" @click="searchFunc">查询</div>
                </div>
            </div>
            <div class="tableContent">
                <div class="tableTop clearfix">
                    <div class="tableBtnList clearfix">
                        <el-button :class="['funcPublicBtn','funcPublicBtnCheckedMall',param.sale == ''||param.sale == 999 ? 'funcPublicBtnChecked':'']" @click="resources('')">全部资源</el-button>
                        <!-- <el-button :class="['funcPublicBtn',param.sale == 1 ? 'funcPublicBtnChecked':'']" @click="resources(1)">特惠资源</el-button> -->
                    </div>
                    <div class="selectConditionTip" v-if="searchList.length>0">当前搜索:
                        <div class="searchCon" v-for="item in searchList" :key="item.name">{{item.name}}
                            <div class="searchConDel" @click="removeSearchCon(item.name)">x</div>
                        </div>
                        <div class="clearSelectAll" @click="reset">清除全部</div>
                    </div>
                </div>
                <div class="cloudTableEL">
                    <el-table :data="tableData" ref="tableList" border stripe highlight-current-row size="mini" height="100%">
                        <!-- <el-table-column label="序号" type="index"></el-table-column> -->
                        <el-table-column label="品名" prop="breed"  show-overflow-tooltip width="80px">
                            <template slot-scope="scope">
                                <div class="cloudTdEL">
                                    {{scope.row.breed}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="产品图片" width="70px">
                            <template slot-scope="scope">
                                    <viewer :images="scope.row.images"> 
                                        <img v-for="(src,index) in scope.row.images" v-show="index < 1" class="viewImg" :src="src" :key="index"/>
                                </viewer>
                            </template>
                        </el-table-column>
                        <el-table-column label="品牌" prop="brand" show-overflow-tooltip width="80px"></el-table-column>
                        <el-table-column label="等级" prop="grade" width="80px" show-overflow-tooltip></el-table-column>
                        <el-table-column label="规格" prop="spe" width="110px" show-overflow-tooltip></el-table-column>
                        <el-table-column label="片数" prop="pieces" width="50px" show-overflow-tooltip></el-table-column>
                        <el-table-column label="立方" prop="cloud_cube" width="80px" show-overflow-tooltip></el-table-column>
                        <el-table-column label="挂牌价" prop="cloud_sales_price" width="80px" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{scope.row.cloud_sales_price==0||scope.row.cloud_sales_price==0.00||scope.row.cloud_sales_price==""?'议价':scope.row.cloud_sales_price}}
                            </template>
                        </el-table-column>
                        <el-table-column label="销售状态" prop="status_text " width="90px">
                            <template slot-scope="scope">
                                {{scope.row.status_text}}
                            </template>
                        </el-table-column>
                        <el-table-column label="货主单位" prop="company" width="100px">
                            <template slot-scope="scope">
                                <div class="consignor">{{scope.row.name}}</div>
                                <div class="consignorPhoneBox">
                                    <img src="/icon/cloudTelephone.png" class="consignorPhoneImg"/>
                                    <div class="consignorPhone">{{scope.row.mobile}}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="区域-仓库" prop="area" width="100px" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{scope.row.inventory_city +"-"+ scope.row.warehouse}}
                            </template>
                        </el-table-column>
                        <el-table-column label="捆包号" prop="bale_no" width="110px" show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作" prop="id" width="50px">
                            <template slot-scope="scope">
                                <img src="/cloud/share_add.png" @click="addCar(scope.row.id)" class="cloudTdELAdd"/>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox" style="text-align:center;margin-top:10px;">
                    <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="param.page" :all.sync="total" :pagesizes.sync="param.per_page" @getPage="getPage"></pagination>
                </div>
                <div class="quickLink">
                    <div class="linkC" @click="gotoCar">
                        <img src="/cloud/share3.png" class="linkImg"/>
                        <div class="linkNumber" v-if="carNumber>0">{{carNumber}}</div>
                    </div>
                    <div class="linkC">
                        <img src="/cloud/share4.png" class="linkImg"/>
                    </div>
                    <div class="linkC">
                        <img src="/cloud/share5.png" class="linkImg"/>
                    </div>
                    <div class="linkC">
                        <img src="/cloud/share6.png" class="linkImg"/>
                    </div>
                </div>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import bottom from './component/bottom.vue'
import pagination from '../../components/pagination.vue'
export default {
    data(){
        return{
            last_page:0,
            total:0,
            tableData:[],
            selectCondition:{},
            selectMore:{
                company:false,
                breed:false,
                brand:false,
                grade:false
            },
            scrollTop:0,
            bannerHeight:0,
            searchContentHeight:0,
            param:{
                per_page:20,
                page:1,
                company_id:"",
                breed_id:"",
                brand_id:"",
                grade_id:"",
                s_cloud_thickness:"",
                e_cloud_thickness:"",
                s_cloud_length:"",
                e_cloud_length:"",
                s_cloud_sales_price:"",
                e_cloud_sales_price:"",
                inventory_city:"",
                warehouse_id:"",
                sale:""
            },
            inventory_city:[],
            warehouse:[],
            searchList:[],
            carNumber:0,
        }
    },
    beforeRouteLeave(to,from,next){
        document.removeEventListener('scroll', this.handleScroll)
        next()
    },
    mounted(){
        this.getCondition()
        this.getCity()
        this.getShopCar()
        document.getElementById("app").style.overflow = "unset";
        document.addEventListener('scroll', this.handleScroll)
    },
    destroyed(){
        document.removeEventListener('scroll', this.handleScroll)
    },
    components:{
        bottom,
        pagination
    },
    methods:{
        navJump(){
            this.$router.push("shopMall")
        },
        resources(type){
            this.param = this.resetSearch(this.param)
            this.param.page = 1;
            for(let key in this.selectCondition){
                this.selectCondition[key].forEach(item=>{
                    item.isChecked = false;
                })
            }
            this.searchList = [];
            this.param.sale = type;
            this.getList();
        },
        getShopCar(){
            this.postFunc("/erp/cloud.cart.count",{},res=>{
                this.carNumber = res.data.data.count;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        gotoManage(){
            this.$router.push("/index")
        },
        searchFunc(){
            this.param.page = 1;
            this.getList();
        },
        getPage(obj){
            this.param.page = obj.currentpage;
            this.param.per_page = obj.pagesize;
        },
        getCity(){
            this.postFunc("/erp/inventory.cloud.area",{},res=>{
                this.inventory_city = res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        getWarehouse(){
            this.postFunc("/erp/inventory.cloud.warehouse",{inventory_city:this.param.inventory_city},res=>{
                this.warehouse = res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        reset(){
            this.param = this.resetSearch(this.param)
            this.param.page = 1;
            for(let key in this.selectCondition){
                this.selectCondition[key].forEach(item=>{
                    item.isChecked = false;
                })
            }
            this.searchList = [];
            this.getList()
        },
        removeSearchCon(name){
            for(let key in this.selectCondition){
                this.selectCondition[key].forEach(item=>{
                    if(item.name == name){
                        item.isChecked = !item.isChecked;
                    }
                })
            }
            this.searchList.forEach((item,index)=>{
                if(item.name == name){
                    this.searchList.splice(index,1)
                }
            })
            this.getList()
        },
        getList(){
            this.searchList = [];
            for(let key in this.selectCondition){
                let arr = "";
                this.selectCondition[key].forEach(item=>{
                    if(item.isChecked){
                        if(key == "company"){
                            arr += item.id + ",";
                        }else{
                            arr += item.name + ",";
                        }
                        this.searchList.push({id:item.id,name:item.name})
                    }
                })
                this.param[key+"_id"] = arr.substring(0,arr.length-1);
            }
            this.postFunc("/erp/inventory.assign.list",this.param,res=>{
                this.last_page=res.data.data.last_page;
                this.$refs.pagination.flag = true;
                this.total=res.data.data.total;
                this.tableData = res.data.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        getMore(type){
            this.selectMore[type] = !this.selectMore[type];
            this.selectCondition[type].forEach((item,index)=>{
                if(type == "company"){
                    if(index>=14){
                        item.isShow = this.selectMore[type]
                    }
                }else{
                    if(index>=10){
                        item.isShow = this.selectMore[type]
                    }
                }
            })
        },
        getCondition(){
            this.postFunc("/erp/inventory.assign.cate",{limit:0},res=>{
                let data = res.data.data;
                for(let key in data){
                    let ind = 0;
                    data[key].forEach(item=>{
                        ind++;
                        if(key == "company"){
                            if(ind>14){
                                item.isShow = false;
                            }else{
                                item.isShow = true;
                            }
                        }else{
                            if(ind>10){
                                item.isShow = false;
                            }else{
                                item.isShow = true;
                            }
                        }
                        item.isChecked = false;
                    })
                }
                this.selectCondition = data;
                this.getList();
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        gotoCar(){
            this.$router.push("/shopCar")
        },
        selectItem(name,type){
            this.selectCondition[type].forEach(item=>{
                if(item.name == name){
                    item.isChecked = !item.isChecked;
                }
            })
        },
        loadImg(e){
            this.bannerHeight = e.target.height;
        },
        handleScroll(){
            this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            this.bannerHeight = this.$refs['bannerImg'].offsetHeight;
            this.searchContentHeight = this.$refs['searchContent'].offsetHeight + 73 - 60;
            if(this.scrollTop > (this.bannerHeight + this.searchContentHeight)){
                document.getElementsByClassName("cloudTableEL")[0].getElementsByClassName("el-table__header-wrapper")[0].setAttribute("style","position: fixed;top:60px;z-index:9;");
                document.getElementsByClassName("cloudTableEL")[0].getElementsByClassName("el-table__body-wrapper")[0].setAttribute("style","height:auto");
                document.getElementsByClassName("cloudTableEL")[0].getElementsByClassName("el-table")[0].setAttribute("style","padding-top:36px;");
            }else{
                document.getElementsByClassName("cloudTableEL")[0].getElementsByClassName("el-table__header-wrapper")[0].setAttribute("style","");
                document.getElementsByClassName("cloudTableEL")[0].getElementsByClassName("el-table__body-wrapper")[0].setAttribute("style","");
                document.getElementsByClassName("cloudTableEL")[0].getElementsByClassName("el-table")[0].setAttribute("style","");
            }
        },
        addCar(id){
            this.postFunc("/erp/cloud.cart.add",{id:id},res=>{
                this.tip("加入采购单成功","success")
                this.getList();
                this.getShopCar();
            },error=>{
                this.tip(error.data.message,"warning")
            })
        }
    },
    watch:{
        "param.page":function(){
            this.getList();
        },
        "param.per_page":function(){
            this.getList();
        },
    }
}
</script>
<style scoped>
    .consignorPhoneBox{position: absolute;right:5px;top:0;bottom:0;margin: auto;height:15px;z-index:1;cursor: pointer;}
    .consignorPhone{display: none;position: absolute;right:-100px;top:0; background-color: #868686;color:#fff;padding:3px 10px;border-radius: 3px;}
    .consignorPhoneImg{display: block;width:10px;}
    .consignorPhoneBox:hover .consignorPhone{display: block;}

    .funcPublicBtnCheckedMall{margin-right:7px;}

    .other_type_box{cursor: pointer;margin-top:5px;}
    .other_type{float: left;font-size: 12px;color: #b21111;}
    .other_type_img{display: block;float: left;width:10px;margin-top:6px;}

    .quickLink{width:45px;height:155px;padding:10px;position: fixed;top:0px;bottom:-50px;margin:auto;right:10px;background-color: #333;}
    .linkC{position: relative;width:25px;height: 25px;margin-bottom:10px;cursor: pointer;}
    .linkImg{display: block;width:100%;height:100%;}
    .linkNumber{width:15px;height:15px;line-height: 15px;color:#fff;font-size: 12px;position: absolute;top:-7px;right:-7px;background-color: #b21111;border-radius: 50%;text-align: center;}


    .cloudTableEL{margin-top:10px;}
    .cloudTdELImg{width:20px;cursor: pointer;}
    .cloudTdELAdd{width:20px;cursor: pointer;}
    .fixedThead{position: fixed;top:0;}

    .tableContent{margin-top:30px;position: relative;}
    .tableTop{}
    .tableBtnList{position: relative;z-index: 1;display: inline-block;}
    .selectConditionTip{position: absolute;top:0;text-align: center;z-index: 0;width:100%;line-height: 33px;font-size: 14px;}
    .searchCon{display: inline-block;margin-right:5px;border:1px solid #b21111;border-radius: 3px; padding:3px 15px 3px 3px;position: relative;font-size: 12px;height: 25px;line-height: 17px;}
    .searchConDel{font-size: 12px;color: #b21111;position: absolute;right:3px;top:1px;cursor: pointer;}
    .clearSelectAll{font-size: 12px;color:#b21111;display: inline-block;cursor: pointer;}
    .cloudTable{margin-top:10px;position: relative;padding-top:33px;}
    .cloudThead{width:100%;position: absolute;top:0;left:0;}
    .cloudThead .cloudTd{background-color: #EBEDF3;font-size: 14px;padding:7px 5px;}
    .cloudBody{}
    .cloudTr{display: flex;flex-direction: row;}
    .cloudTd{flex:1;flex-basis:83.33px ; border-right:1px solid #ccc;font-size: 12px;padding:5px;word-break:break-all;}

    .cloudCountBox{width:1100px;margin:auto;margin-top:-60px;}
    .selectConditionBox{background-color: #EFF0F4;padding:15px;border-radius: 3px;position: relative;box-shadow: 0 5px 7px #ccc;}
    .selectCompany{position: relative;padding:0 100px 0 40px;min-height:39px;}
    .selectCompany .title{font-size: 14px;font-weight: 600;width:35px;position: absolute;top:0px;left:0px;}
    .selectCompany .titleC{font-size: 14px;font-weight: 600;width:35px;position: absolute;top:10px;left:0px; margin: auto;}
    .selectCompany .titleCO{top:14px;}
    .companyBoxC{border-bottom:1px solid #C7CEDC;}
    .companyBox{width:100%;}
    .companyBoxInp{padding-top:10px;}
    .companyC{position: relative;width:115px;height: 69px;float: left;margin-right:15px;margin-bottom:15px;border-radius: 5px;overflow: hidden;border:1px solid #EFF0F4;cursor: pointer;}
    .companyLogo{ display: block;width:100%;height: 100%;transition: all 1s;}
    .companyC:hover .companyLogo{transform: scale(1.2);}
    .companyBox .companyNameBox{width:100%;position: absolute;bottom:0;left:0;height:25px;}
    .companyBox .companyNameBg{width:100%;height:100%;position: absolute;bottom:0;left:0;opacity:0.5;background-color:#060E4E;}
    .companyBox .companyName{color: #fff;font-size: 12px;text-align: center;line-height: 25px;position: relative;z-index:1;}
    .companyChecked{border:1px solid #b21111;}
    .companyGou{width:15px;height:15px;position: absolute;top:5px;right:5px;z-index:2;}
    .selectCompany .more{color:#b21111;font-size: 12px;width:80px;position: absolute;top:5px;right:0px;font-weight: 600;cursor: pointer;line-height: 25px;}
    .selectCompany .moreName{float: left;display: block;}
    .selectCompany .moreImg{float: left;width:10px;display: block;margin-top:10px;margin-left:5px;}
    .selectCompany .moreImgChecked{transform: rotate(180deg);}
    .conditionName{display: inline-block;border:1px solid #EFF0F4;font-size: 12px;font-weight: 600;margin:5px;padding:5px 15px;color:#333;cursor: pointer;box-sizing: border-box;}
    .conditionNameChecked{border:1px solid #b21111;border-radius: 3px;background-color: #fff;background: url('/icon/checkeded.png') no-repeat 100% 100%;background-size: 15px 15px;color:#b21111;}
    .companyInpBox{float: left;margin-right:20px;}
    .companyInpName{float: left;font-size: 12px;color:#333;line-height: 28px;margin-right:5px;}
    .companyInp{float: left;width:100px;margin-right:5px;font-size: 12px;}
    .companyInpG{width:100px;}
    .selectBtnList{position: absolute;bottom:20px;right: 15px;}
    .selectReset{font-size: 12px;color:#b21111;float: left;line-height: 28px;margin-right:20px;cursor: pointer;}
    .selectBtnChecked{font-size: 12px;display: inline-block;color: #fff;background-color: #b21111;padding:6px 15px;float: left;border-radius: 3px;cursor: pointer;}

    .cloud{min-height: 100vh;padding-bottom:252px;box-sizing: border-box;position: relative;min-width: 1400px;padding-top:60px;}
    .top{width:100%;position: fixed;top:0;left:0;min-width: 1400px;height: 60px;z-index:9;}
    .topBg{width:100%;height: 100%;background-color: #000;opacity: 0.3;position: absolute;z-index:0;}
    .topContent{width:1100px;margin: auto;height: 60px;position: relative;z-index:1;}
    .topLogo{width:160px;display: block;float: left;margin-top:10px;position:absolute;top:0;bottom:0;left:40px;margin: auto;z-index:1;cursor: pointer;}
    .CloudBanner{width:100%;display: block;min-width: 1200px;}
    .meunList{float: left;margin-top:13px;}
    .meun{display: inline-block;color:#fff;margin-left:50px;padding:5px 0;font-size: 14px;letter-spacing: 1px;cursor: pointer;}
    .meunChecked{color:#5AF7F1;border-bottom:2px solid #5AF7F1;}
    .topF .topBg{opacity: 1;background-color: #35363A;}/*#d2dde4*/
    /* .topF .topContent .meun{color: #000;} */
    .topF .topContent .meunChecked{color:#5AF7F1;border-bottom:2px solid #5AF7F1;}
</style>